import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'

export const SWELLCHAIN = {
  name: 'swellchain',
  chainId: 1923,
  averageBlockTimeSeconds: 2,
  explorerUrl: 'https://explorer.swellnetwork.io',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: 'https://explorer.swellnetwork.io/api',
  publicRpcUrls: ['https://rpc.ankr.com/swell', 'https://swell-mainnet.alt.technology'],
  etherscanSupported: true,
  getPrivateRpcUrls: () => {
    const swell: string[] = []
    process.env.ROUTEME_API_KEY && swell.push(`https://lb.routeme.sh/rpc/1923/${process.env.ROUTEME_API_KEY}`)
    process.env.ANKR_API_KEY && swell.push(`https://rpc.ankr.com/swell/${process.env.ANKR_API_KEY}`)
    process.env.INFURA_API_KEY && swell.push(`https://swellchain-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    return swell
  },
} as const satisfies ChainConfig
